import { render } from "./KISIndex.vue?vue&type=template&id=c2606a88&scoped=true"
import script from "./KISIndex.vue?vue&type=script&lang=js"
export * from "./KISIndex.vue?vue&type=script&lang=js"

import "./KISIndex.vue?vue&type=style&index=0&id=c2606a88&lang=less"
import "./KISIndex.vue?vue&type=style&index=1&id=c2606a88&scoped=true&lang=css"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2606a88"]])

export default __exports__